import React from 'react';
import { useSelector } from 'react-redux';

import _ from 'underscore';
import { Form, Select } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';
import { ListSubtotal } from 'ui/components';
import { currencyFormat } from 'utilities/common';

const PaymentMethods = [
  { value: 'Kas Tunai', label: 'Kas Tunai' },
  { value: 'Cek&Giro', label: 'Cek & Giro' },
  { value: 'Transfer Bank', label: 'Transfer Bank' },
  { value: 'Kartu Kredit', label: 'Kartu Kredit' },
];

const ppnOptions = [
  { value: 11, label: 'PPn 11' },
  { value: 1.1, label: 'PPn 1.1' },
  { value: 12, label: 'PPn 12' },
  { value: 1.2, label: 'PPn 1.2' },
];

const pphOptions = [
  { value: 2, label: 'Pasal 23' },
  { value: 10, label: 'Pasal 4(2)' },
];

const initialState = {
  nominal: null,
  discount: null,
  ppn: null,
  pph: null,
  down_payment: null,
  isDp: false,
};

export const FormSubtotal = ({
  project,
  onChange,
  products,
  data,
  isLoading
}) => {
  const StateForm = useSelector((state) => state?.Form);
  const [
    { nominal, discount, ppnSelected, pphSelected, down_payment, isDp },
    setState,
  ] = React.useState(initialState);

  const $handlePPn = async (e) => {
    setState((prevState) => ({...prevState, ppnSelected: e}));
  }

  const $handlePPh = async (e) => {
    setState((prevState) => ({...prevState, pphSelected: e}));
  }

  const $ppnNominal = () => {
    let ppn = 0
    if (ppnSelected) {
      ppn = ppnSelected?.value
    }

    let result = (nominal - discount) * (ppn / 100)

    if (result > 0) {
      result = result.toFixed(2)
    }

    return parseFloat(result)
  }

  const $pphNominal = () => {
    let pph = 0
    if (pphSelected) {
      pph = pphSelected?.value
    }

    let result = (nominal - discount) * (pph / 100)
    if (result > 0) {
      result = result.toFixed(2)
    }

    return parseFloat(result)
  }

  const $totalCharges = () => {
    let dpn = 0
    if (down_payment) {
      dpn = down_payment?.nominal
    }

    return (nominal - discount) + $ppnNominal() - $pphNominal() - dpn
  }

  const $handleDownPaymentChange = async (e, n) => {
    let newDp = { ...down_payment};

    if (n === 'is_dp') {
      let dp = false
      newDp = {nominal: 0, payment_method: null}

      if (!isDp) {
        dp = true
      } else {
        dp = false
      }

      setState((prevState) => ({...prevState, isDp: dp, down_payment: newDp}));
    }else {
      if (n === 'nominal') {
        newDp[n] = e?.target?.valueNumber
      }

      if (n === 'payment_method') {
        newDp[n] = e
      }

      setState((prevState) => ({...prevState, down_payment: newDp}));
    }
  }

  React.useEffect(() => {
    let dp = null

    if (isDp && down_payment) {
      dp = {
        id: down_payment?.id,
        nominal: down_payment?.nominal,
        payment_method: down_payment?.payment_method?.value,
      }
    }

    onChange({
      nominal,
      discount,
      ppn: ppnSelected?.value || 0,
      pph: pphSelected?.value || 0,
      pphSelected,
      down_payment: dp
    });
  }, [nominal, discount, ppnSelected, pphSelected, down_payment])

  React.useEffect(() => {
    if (!data) return

    let ppnSelected = null
    _.each(ppnOptions, function(x) {
      if (x.value === data?.ppn_percentage) {
        ppnSelected = x
      }
    })

    let pphSelected = null
    _.each(pphOptions, function(x) {
      if (x.value === data?.pph_percentage) {
        pphSelected = x
      }
    })

    let dp = null
    let isDp = false
    if (data?.payments?.length > 0) {
      let ivpay = data?.payments[0]

      let pm = null
      if (ivpay?.payment_method) {
        _.each(PaymentMethods, (i) => {
          if (i?.value === ivpay?.payment_method) {
            pm = i
          }
        })
      }

      dp = {
        id: ivpay?.id,
        nominal: ivpay?.nominal,
        payment_method: pm
      }

      isDp = true
    }

    setState((prevState) => ({
      ...prevState,
      nominal: data?.nominal,
      discount: data?.discount,
      ppnSelected: ppnSelected,
      pphSelected: pphSelected,
      down_payment: dp,
      isDp: isDp
    }));
  }, [data])

  return isLoading ? (
    <SkeletonsForm count={5} />
  ) : (
    <div className='mt-1'>
      <div className='py-2'>
        <Form.Input
          required
          value={nominal}
          onChange={(e) =>
            setState((prevState) => ({
              ...prevState,
              nominal: e.target.valueNumber,
            }))
          }
          type="number"
          label="Nominal (Rp)"
          error={StateForm?.errors?.nominal}
        />

        <Form.Input
          value={discount}
          onChange={(e) =>
            setState((prevState) => ({
              ...prevState,
              discount: e.target.valueNumber,
            }))
          }
          type="number"
          label="Diskon (Rp)"
        />

        <div className='row mb-3'>
          <div className='col-6'>
            <div className="page-pretitle">Pilih PPn</div>
            <Select
              isClearable
              classNamePrefix={
                StateForm?.errors?.ppn
                  ? 'is-invalid'
                  : 'select'
                }
              placeholder=""
              value={ppnSelected}
              options={ppnOptions}
              onChange={(e) => $handlePPn(e)}
              error={StateForm?.errors?.ppn}
            />
          </div>
          <div className='col-6'>
            <ListSubtotal
              className='border-0 mt-2'
              content={$ppnNominal() > 0 ? `${currencyFormat($ppnNominal())}` : 0}
              colContent='fs-7'
            />
          </div>
        </div>

        <div className='row mb-3'>
          <div className='col-6'>
            <div className="page-pretitle">Pilih PPh</div>
            <Select
              isClearable
              classNamePrefix={
                StateForm?.errors?.pph
                  ? 'is-invalid'
                  : 'select'
                }
              placeholder=""
              value={pphSelected}
              options={pphOptions}
              onChange={(e) => $handlePPh(e)}
              error={StateForm?.errors?.pph}
            />
          </div>
          <div className='col-6'>
            <ListSubtotal
              className='border-0 mt-2'
              content={$pphNominal() > 0 ? `(${currencyFormat($pphNominal())})` : 0}
              colContent='fs-7'
            />
          </div>
        </div>

        <div className='row my-1'>
          <div className='col-6'>
            <Form.Checkbox
              onChange={(e) => $handleDownPaymentChange(e, 'is_dp')}
              iconSize={18}
              value={isDp}
              label="Pemotongan"
            />
          </div>
          {isDp && (
            <>
              <div className='col-6'>
                <Form.Input
                  value={down_payment?.nominal}
                  onChange={(e) => $handleDownPaymentChange(e, 'nominal')}
                  type="number"
                  error={StateForm?.errors?.['down_payment.nominal']}
                />
              </div>
              <div className='col-12'>
                <Select
                  isClearable
                  classNamePrefix='select'
                  placeholder=""
                  value={down_payment?.payment_method}
                  options={PaymentMethods}
                  onChange={(e) => $handleDownPaymentChange(e, 'payment_method')}
                  error={StateForm?.errors?.['down_payment.payment_method']}
                />

                {StateForm?.errors?.['down_payment.payment_method'] ? (
                  <div
                    className="invalid-feedback"
                    style={{ display: 'block' }}
                  >
                    {StateForm?.errors?.['down_payment.payment_method']}
                  </div>
                ) : null}
              </div>
            </>
          )}
        </div>
      </div>
      <ListSubtotal
        colTitle='fs-4 fw-semibold'
        title="Total Tagihan"
        content={currencyFormat($totalCharges() || 0)}
        colContent='fs-4'
      />
    </div>
  );
};
